import { render, staticRenderFns } from "./ProductsWidget.vue?vue&type=template&id=3e0702ae&scoped=true&"
import script from "./ProductsWidget.vue?vue&type=script&lang=js&"
export * from "./ProductsWidget.vue?vue&type=script&lang=js&"
import style0 from "./ProductsWidget.vue?vue&type=style&index=0&id=3e0702ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0702ae",
  null
  
)

export default component.exports